/** Texto del tag cuando el override "App" está activo (FR-014). */
export const APP_TAG_LABEL = 'App'

/** Texto accesible del icono genérico de promoción (sin texto CMS, FR-009/FR-010). */
export const GENERIC_PROMO_LABEL = 'Promoción disponible'
